"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _Icon = _interopRequireDefault(require("../../../IconicDisplayElements/Icon"));

var _DataGridButton = _interopRequireDefault(require("../DataGridButton"));

var _strings = require("../../../../constants/strings");

var _Header = require("./Header.styles");

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _unsupportedIterableToArray(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }

function _unsupportedIterableToArray(o, minLen) { if (!o) return; if (typeof o === "string") return _arrayLikeToArray(o, minLen); var n = Object.prototype.toString.call(o).slice(8, -1); if (n === "Object" && o.constructor) n = o.constructor.name; if (n === "Map" || n === "Set") return Array.from(o); if (n === "Arguments" || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(n)) return _arrayLikeToArray(o, minLen); }

function _arrayLikeToArray(arr, len) { if (len == null || len > arr.length) len = arr.length; for (var i = 0, arr2 = new Array(len); i < len; i++) { arr2[i] = arr[i]; } return arr2; }

function _iterableToArrayLimit(arr, i) { if (typeof Symbol === "undefined" || !(Symbol.iterator in Object(arr))) return; var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var Header = function Header(_ref) {
  var config = _ref.config,
      headerGroups = _ref.headerGroups;

  var dropdownRef = _react.default.useRef(null); // hook for filterOpen bool


  var _React$useState = _react.default.useState(false),
      _React$useState2 = _slicedToArray(_React$useState, 2),
      filtersOpen = _React$useState2[0],
      setFiltersOpen = _React$useState2[1]; // logic to close dropdown on click outside


  function handleClickOutside(event) {
    if (dropdownRef.current && !dropdownRef.current.contains(event.target)) {
      setFiltersOpen(false);
    }
  }

  _react.default.useEffect(function () {
    document.addEventListener('mousedown', handleClickOutside);
    return function () {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  var handleFilterOpen = function handleFilterOpen() {
    setFiltersOpen(!filtersOpen);
  }; // helper method for the sort icon


  var sortIcon = function sortIcon(column) {
    return column.isSorted ? /*#__PURE__*/_react.default.createElement("span", null, column.isSortedDesc ? /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: "sort-arrow",
      iconName: "sort-amount-down",
      size: "small",
      dataTestId: "sort-amount-down"
    }) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: "sort-arrow",
      iconName: "sort-amount-up",
      size: "small",
      dataTestId: "sort-amount-up"
    })) : /*#__PURE__*/_react.default.createElement(_Icon.default, {
      className: "sort-arrow",
      iconName: "sort-alt",
      size: "small",
      dataTestId: "sort-amount-down-alt"
    });
  };

  return /*#__PURE__*/_react.default.createElement(_Header.TableHeader, null, (config.filter || config.search) && /*#__PURE__*/_react.default.createElement(_Header.HeaderRow, null, config.search && /*#__PURE__*/_react.default.createElement(_Header.StyledSearchBar, {
    initialSearchTerm: config.initialSearchTerm,
    onSearch: config.searchFunction
  }), // disabling the filter for now
  config.filter && false && /*#__PURE__*/_react.default.createElement("div", {
    className: "drop-down-wrapper",
    ref: dropdownRef
  }, /*#__PURE__*/_react.default.createElement(_DataGridButton.default, {
    alignment: "right",
    filtersOpen: filtersOpen,
    dataTestId: "datagrid-filter",
    onClick: handleFilterOpen
  }, _strings.dataGrid.filter, /*#__PURE__*/_react.default.createElement(_Header.FilterIcon, {
    colorTheme: "primary",
    dataTestId: "filter-button",
    className: "filter-button",
    iconName: "filter",
    size: "small"
  })), filtersOpen && /*#__PURE__*/_react.default.createElement("div", {
    className: "drop-down"
  }, headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/_react.default.createElement(_Header.HeaderRow, headerGroup.getHeaderGroupProps(), headerGroup.headers.map(function (column) {
      return column.canFilter ? /*#__PURE__*/_react.default.createElement(_Header.FilterColumn, column.getHeaderProps(), /*#__PURE__*/_react.default.createElement(_Header.FilterHeader, {
        dataTestId: "header-".concat(column.id)
      }, column.render('Header')), /*#__PURE__*/_react.default.createElement("div", null, column.canFilter ? column.render('Filter') : null)) : null;
    }));
  }), /*#__PURE__*/_react.default.createElement("button", {
    className: "reset-button",
    onClick: function onClick() {}
  }, "Reset")))), config.headers && headerGroups.map(function (headerGroup) {
    return /*#__PURE__*/_react.default.createElement(_Header.ColumnNamesWrapper, headerGroup.getHeaderGroupProps(), /*#__PURE__*/_react.default.createElement(_Header.HeaderRow, null, headerGroup.headers.map(function (column) {
      return /*#__PURE__*/_react.default.createElement(_Header.HeaderCell, _extends({
        alignment: column.alignment
      }, column.getHeaderProps(column.getSortByToggleProps())), column.canSort ? /*#__PURE__*/_react.default.createElement(_DataGridButton.default, {
        alignment: column.alignment,
        buttonWidth: "fitText",
        onClick: column.getHeaderProps(column.getSortByToggleProps()).onClick,
        dataTestId: "datagrid-header-button-".concat(column.accessor)
      }, column.render('Header'), column.canSort && sortIcon(column)) : /*#__PURE__*/_react.default.createElement(_Header.HeaderLabel, null, column.render('Header')));
    })));
  }));
};

Header.propTypes = {
  /** An Objects that determines which areas of the grid to show and some pagination variables */
  config: _propTypes.default.shape({
    /** show headers. default is true */
    headers: _propTypes.default.bool,

    /** initial search term - used primarily to clear the search bar */
    initialSearchTerm: _propTypes.default.string,

    /** show Search bar. default is false */
    search: _propTypes.default.bool,

    /** function to execute on search */
    searchFunction: _propTypes.default.func,

    /** show filters. default is false */
    filter: _propTypes.default.bool
  }).isRequired,

  /** Header groupings - see the datagrid component and react-table for more details
   * and yes, ignoring lint on this thing because i am in a bit of a hurry.  todo: fix lint exclusion
   */
  headerGroups: _propTypes.default.array.isRequired // eslint-disable-line

};
var _default = Header;
exports.default = _default;